import * as React from "react";
import styles from "./DiagnosticsWrapper.module.scss";
import AuthenticateGoogleCalendar from "../AuthenticateGoogleCalendar/AuthenticateGoogleCalendar";
import { cn } from "../../../../helpers";
import FindExportedAppointments from "../FindExportedAppointments/FindExportedAppointments";
import ExportActiveClients from "../ExportActiveClients/ExportActiveClients";
import ExportRecheckList from "../ExportRecheckList/ExportRecheckList";
import ClientRepairDiagnostics from "../ClientRepairDiagnostics/ClientRepairDiagnostics";

export default function DiagnosticsWrapper() {
    type TabItem = {
        key: string;
        title: React.ReactNode;
        component: React.ReactNode;
        show?: boolean;
    };

    const [activeKey, setActiveKey] = React.useState<string>(
        "client-repair-diagnostics"
    );

    const tabs: TabItem[] = [
        {
            key: "client-repair-diagnostics",
            title: "Client Repair Diagnostics",
            component: <ClientRepairDiagnostics />,
            show: true,
        },
        {
            key: "export-active-clients",
            title: "Export Active Clients",
            component: <ExportActiveClients />,
            show: false,
        },
        {
            key: "export-recheck-list",
            title: "Export Recheck List",
            component: <ExportRecheckList />,
            show: false,
        },
        {
            key: "export-exported-appointments",
            title: "Exported Appointments",
            component: <FindExportedAppointments />,
            show: true,
        },
        {
            key: "authenticate-google-calendar",
            title: "Authenticate Google Calendar",
            component: <AuthenticateGoogleCalendar />,
            show: true,
        },
    ];

    const tabsToShow = tabs.filter((t) => t.show);

    const getActiveComponent = () => {
        const activeTab = tabsToShow.find((tab) => tab.key === activeKey);
        return activeTab?.component || null;
    };

    return (
        <div className={cn(styles.layoutWrapper, "v2-page")}>
            <div className={styles.sidebar}>
                <div className={styles.card}>
                    <div className={styles.tabGroup}>
                        {tabsToShow.map((tab) => (
                            <div
                                key={tab.key}
                                className={`${styles.tabItem} ${
                                    activeKey === tab.key ? styles.tabItemActive : ""
                                }`}
                                onClick={() => setActiveKey(tab.key)}
                            >
                                <div>{tab.title}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className={styles.mainContent}>{getActiveComponent()}</div>
        </div>
    );
}
